'use strict';

angular.module('accessRequestModule')
.factory('accessRequestViewOptions', accessRequestViewOptions);

function accessRequestViewOptions(
    extendDeep,
    resourceViewOptions,
    listView
) {
    var options = angular.copy(resourceViewOptions);

    extendDeep(options, {
        toolbar: [],
        list: {
            columns: [
                {
                    label: 'Name',
                    name: 'name',
                    sortable: true
                },
                {
                    label: 'Email',
                    name: 'email',
                    sortable: true
                },
                {
                    label: 'Company',
                    name: 'company',
                    sortable: true
                },
                {
                    label: 'Status',
                    name: 'status',
                    sortable: true,
                },
                {
                    label: 'Created At',
                    name: 'created_at',
                    sortable: true,
                    template: '<span class="resource-ui-lastmodified">{{ model.created_at | date }}</span>'
                },
                {
                    label: 'Updated At',
                    name: 'updated_at',
                    sortable: true,
                    template: '<span class="resource-ui-lastmodified">{{ model.updated_at | date }}</span>'
                },
                {
                    label: 'R&A Contact',
                    name: 'ra_contact',
                    sortable: true,
                },
            ]
        },
        views: [listView],
        resourceFilters: [
            {
                label: 'Status',
                name: 'status',
                defaultValueLabel: 'All',
                options: [
                    {
                        label: 'All', value: ''
                    },
                    {
                        label: 'Approved', value: 'approved'
                    },
                    {
                        label: 'Rejected', value: 'rejected'
                    },
                    {
                        label: 'Pending', value: 'pending'
                    }
                ]
            },
        ]
    });

    return options;
}
